module.exports = __webpack_public_path__ + "img/logo.a14dc2a7.svg";